import { createQueryKeyStore } from '@lukemorales/query-key-factory'
import { useQuery } from '@tanstack/react-query'

import { graphql_multi_call } from '@repo/common/queries/schemas/server_user_query'

import { query_get_version } from './versions_graphql'

export const keys = createQueryKeyStore({
  versions: {
    server: null,
  },
})

export function useGetVersion() {
  return useQuery({
    queryKey: keys.versions.server.queryKey,
    queryFn: async () => {
      return await graphql_multi_call({
        query: query_get_version,
      })
    },
  })
}
